<template>
    <span>
        <PatientSelector
            v-if="shouldDisplayPatientsDropdown"
            :sub-label="formattedLabel(
                metadata[`description${this.upperLocale}`],
                required
            )"
            data-testid="requester-link-dropdown"
            @onDropDownChange="resetAndUpdateMetaValues"
        />
        <v-radio-group
            v-else
            class="body-2"
            :value="value"
            :outline="outline"
            type="radio"
            role="radiogroup"
            tabindex="-1"
            validate-on-blur
            :aria-label="formattedAriaLabel(
                metadata[`description${this.upperLocale}`],
                required
            )"
            :label="formattedLabel(
                metadata[`description${this.upperLocale}`],
                required
            )"
            :rules="[
                v => v === 0 || v === 1 || $t('appt.errors.' + metadata['name'])
            ]"
            data-testid="requester-link-radio"
            :data-meta-id="metadata.id"
            :id="metadata.name"
            @change="emitValue"
        >
            <v-radio :class="requesterLink0Classes" :label="$t('appt.placeholder.requester_link_0')" :value="0" tabindex="-1" />
            <v-radio :class="requesterLink1Classes" :label="$t('appt.placeholder.requester_link_1')" :value="1" tabindex="-1" />
        </v-radio-group>
    </span>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { forEach, map, mapKeys, camelCase, get, filter } from 'lodash';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import PatientSelector from '@/components/metadata/inputs/PatientSelector/PatientSelector';
import { getSelectedPatientMetaValues } from '@/components/metadata/inputs/PatientSelector/helpers/getSelectedPatientMetaValues';
import { authModule, isUsingKc } from '@/utils';
export default {
    name: 'requester-link',
    components: {
        PatientSelector,
    },
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: Number, required: false, default: 0 },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
        otherMetadata: { type: Array, required: true },
        previousAppointmentClientData: { type: Object, required: true },
    },
    data() {
        return {
            selected: null,
        };
    },
    computed: {
        ...mapGetters({
            isClicSante: 'isClicSante',
            upperLocale: 'upperLocale',
            getLoggedUser: `${authModule}/getLoggedUser`,
            getPatients: `${authModule}/getPatients`,
            getAccessToken: 'jwt/getAccessToken',
            getLoggedUserCommunication: `${authModule}/getLoggedUserCommunication`,
            serviceHasDynamicFilter: 'services/serviceHasDynamicFilter',
            getDynamicFilterMetadataValues: 'services/getDynamicFilterMetadataValues',
            getOwnerPatient: `${authModule}/getOwnerPatient`,
            getCopySelectedServiceMetadataValues: `services/getCopySelectedServiceMetadataValues`
        }),
        appendIcon() {
            return this.withIcon ? 'far fa-user' : '';
        },
        requesterLink0Classes() {
            return {
                'body-2': true,
                'selected': this.value === 0,
            };
        },
        requesterLink1Classes() {
            return {
                'body-2': true,
                'selected': this.value === 1,
            };
        },
        shouldDisplayPatientsDropdown() {
            const isProfileCompleted = isUsingKc
                ? !!(get(this.getOwnerPatient, 'firstName') && get(this.getOwnerPatient, 'lastName'))
                : this.getAccessToken;

            return isProfileCompleted &&
                    this.isClicSante &&
                    this.getLoggedUser &&
                    this.getPatients &&
                    this.getPatients.length;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
        resetAndUpdateMetaValues(dropDownProfilePatientData) {
            const patientData = {
                ...mapKeys(this.previousAppointmentClientData, (value, key) => camelCase(key)),
                ...dropDownProfilePatientData,
                nam: get(dropDownProfilePatientData, 'nam', ''),
            };
            this.updateMetaValues(map(this.otherMetadata, meta => {
                return { ...meta, value: '' };
            }));

            this.updateMetaValues(getSelectedPatientMetaValues(
                patientData,
                this.otherMetadata,
                this.getPatients,
                this.getLoggedUserCommunication,
                this.serviceHasDynamicFilter,
                this.getDynamicFilterMetadataValues,
                filter(this.getCopySelectedServiceMetadataValues, m => m.status)
            ));
            this.$emit('updatePatientUuid', patientData.uuid);
        },

        updateMetaValues(valuesToUpdate) {
            forEach(valuesToUpdate, (metaValues) => {
                this.$emit('updateProfileMetadata', metaValues);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    .v-radio label {
        font-size: 14px;
    }

    .v-radio.selected label {
        color: black;
    }

    .v-input--radio-group label {
        font-size: 14px;
    }
</style>
